import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';
import { SendEmailOtpResponse } from './verifyEmailFormActions';

export enum VerifyEmailActionTypes {
    SEND_OTP_REQUEST = 'SEND_OTP_REQUEST',
    SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS',
    SEND_OTP_FAILURE = 'SEND_OTP_FAILURE',
    VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE',
    DISABLE_VERIFY_EMAIL_FAILURE = 'DISABLE_VERIFY_EMAIL_FAILURE',
    TOO_MANY_SEND_OTP_REQUESTS = 'TOO_MANY_SEND_OTP_REQUESTS',
    TOO_MANY_VERIFY_OTP_REQUESTS = 'TOO_MANY_VERIFY_OTP_REQUESTS',
    SET_VERIFYING_EAMIL = 'SET_VERIFYING_EAMIL',
    VALIDATE_PASSWORD_SUCCESS = 'VALIDATE_PASSWORD_SUCCESS',
    VALIDATE_PASSWORD_FAILED = 'VALIDATE_PASSWORD_FAILED',
    VLIDATE_PASSWORD_REQUEST = 'VLIDATE_PASSWORD_REQUEST',
    SET_PASSWORD_VALID_FALSE = 'SET_PASSWORD_VALID_FALSE',
    SET_VARIFY_EMAIL_FROM_UPDATE_EMAIL = 'SET_VARIFY_EMAIL_FROM_UPDATE_EMAIL',
    CLEAR_OTP_TIMES = 'CLEAR_OTP_TIMES',
}

export type VerifyEmailAction =
    | {
          type: VerifyEmailActionTypes.VERIFY_EMAIL_FAILURE;
      }
    | { type: VerifyEmailActionTypes.SEND_OTP_REQUEST }
    | {
          type: VerifyEmailActionTypes.SEND_OTP_SUCCESS;
      }
    | {
          type: VerifyEmailActionTypes.SEND_OTP_FAILURE;
      }
    | {
          type: VerifyEmailActionTypes.DISABLE_VERIFY_EMAIL_FAILURE;
      }
    | {
          type: VerifyEmailActionTypes.TOO_MANY_SEND_OTP_REQUESTS;
          payload: boolean;
      }
    | {
          type: VerifyEmailActionTypes.TOO_MANY_VERIFY_OTP_REQUESTS;
          payload: boolean;
      }
    | {
          type: VerifyEmailActionTypes.SET_VERIFYING_EAMIL;
          payload: string;
      }
    | {
          type: VerifyEmailActionTypes.VALIDATE_PASSWORD_SUCCESS;
      }
    | {
          type: VerifyEmailActionTypes.VLIDATE_PASSWORD_REQUEST;
          payload: string;
      }
    | {
          type: VerifyEmailActionTypes.VALIDATE_PASSWORD_FAILED;
      }
    | {
          type: VerifyEmailActionTypes.SET_PASSWORD_VALID_FALSE;
      }
    | {
          type: VerifyEmailActionTypes.SET_VARIFY_EMAIL_FROM_UPDATE_EMAIL;
      }
    | { type: VerifyEmailActionTypes.CLEAR_OTP_TIMES; payload: {} };
